import "./Mainimage.css"

const Mainimage = () => {
    return (
        <div className="main-image-container"></div>
    )
}

export default Mainimage